export default __webpack_public_path__ + "static/media/logo.f8907003.png";